import { Component, OnInit } from '@angular/core';
import { ServiceBase } from '../services-base/service.base.class';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'kts-automation',
  templateUrl: './../services-base/service.base.template.html',
  styleUrls: ['./../services-base/serivce.base.styles.scss']
})
export class AutomationComponent extends ServiceBase implements OnInit {

  title = 'Automation and Systems';
  contents = [
    {
      subTitle: 'Automation is Key',
      textcontents: [
        'Katiso is capable of full, in-house PLM development & improvement of new and existing production systems, all Turn-Key.',
        'Our strengths include utilizing high-performance control systems, programmable logic controls (Allan Bradley, Siemens, etc.) along with complete solutions in terms of planning, system development, and installation through to the commissioning process and customer support.',
      ],
      imagePath: '/automation/1.jpg'
    }, {
      subTitle: 'Putting Clients First',
      textcontents: [
        'The Katiso family preserves its flexibility by evolving to suit our clients needs. We pride ourselves in working with cutting edge technologies to provide you with elegant and innovative solutions, whilst maintaining the professional level of service and quality our reputation demands.'],
      imagePath: '/automation/2.jpg'
    }, {
      subTitle: 'Our Automation Services Include:',
      textcontents: [
        'Automation, Integration & Implementation Of New & Existing Systems',
        'Installation , Commissioning & Full Production Support',
        'Transfer Systems Design',
        'Process Planning & Simulation'],
      imagePath: '/automation/3.jpg'
    }];
    constructor(meta: Meta, title: Title) {
        super();
    title.setTitle('Automation Services | Katiso Engineering and Automation');

    meta.updateTag(
        {
            name: 'keywords', content: 'Katiso Engineering, Automation, Systems, Automotive Supplier, PLM, development, improvement, control, logic, systems development, integration, transfer, process, Transfer Systems Design'
        }
        )
        meta.updateTag(
            {

                name: 'description', content: 'Our strengths include utilizing high-performance control systems, programmable logic controls (Allan Bradley, Siemens, etc.) along with complete solutions in terms of planning, system development, and installation through to the commissioning process and customer support. | Katiso Engineering and  Automation'
            }
    
        )
    
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/services/automation/automation.component.ts